import html2PDF from "jspdf-html2canvas";

class Calculators {
    constructor() {
        // Emable all calculators on page-load
        $(".calculate-form").removeClass("loading");

        this.listeners();

        // Calculators
        this.flowCalculator();
        this.pressuredropCalculator();
        this.expansionCalculator();
    }

    flowCalculator() {
        if (!document.querySelector(".block-calculator-fc")) {
            return;
        }

        var calculate = document.getElementById("gpa-fc-calculate");
        var speed = document.getElementById("gpa-fc-speed");
        var diameter = document.getElementById("gpa-fc-diameter");
        var flow = document.getElementById("gpa-fc-flow");
        var type = document.getElementById("gpa-fc-type");
        var flowUnit = document.getElementById("gpa-fc-flow-unit");
        var flowUnitLabel = document.getElementById("gpa-fc-flow-label");
        var flowConv = 3.6;

        // Default value = flow
        flow.disabled = true;
        speed.disabled = false;
        diameter.disabled = false;

        //Selectboxes
        type.addEventListener("input", function () {
            if ("flow" == type.value) {
                flow.disabled = true;
                speed.disabled = false;
                diameter.disabled = false;
            } else if ("diameter" == type.value) {
                flow.disabled = false;
                speed.disabled = false;
                diameter.disabled = true;
            } else if ("speed" == type.value) {
                flow.disabled = false;
                speed.disabled = true;
                diameter.disabled = false;
            }
        });

        flowUnit.addEventListener("input", function () {
            if ("l_s" == flowUnit.value) {
                flowConv = 1;
                flowUnitLabel.innerHTML =
                    "<i>" +
                    document.getElementById("fc_unit_lang_1").value +
                    "</i>";
            } else if ("l_m" == flowUnit.value) {
                flowConv = 60;
                flowUnitLabel.innerHTML =
                    "<i>" +
                    document.getElementById("fc_unit_lang_2").value +
                    "</i>";
            } else if ("l_h" == flowUnit.value) {
                flowConv = 3600;
                flowUnitLabel.innerHTML =
                    "<i>" +
                    document.getElementById("fc_unit_lang_3").value +
                    "</i>";
            } else if ("m3_s" == flowUnit.value) {
                flowConv = 0.001;
                flowUnitLabel.innerHTML =
                    "<i>" +
                    document.getElementById("fc_unit_lang_4").value +
                    "</i>";
            } else if ("m3_m" == flowUnit.value) {
                flowConv = 0.06;
                flowUnitLabel.innerHTML =
                    "<i>" +
                    document.getElementById("fc_unit_lang_5").value +
                    "</i>";
            } else if ("m3_h" == flowUnit.value) {
                flowConv = 3.6;
                flowUnitLabel.innerHTML =
                    "<i>" +
                    document.getElementById("fc_unit_lang_6").value +
                    "</i>";
            }

            if ("flow" == type.value) {
                flowFunc();
            } else if ("diameter" == type.value) {
                diameterFunc();
            } else if ("speed" == type.value) {
                speedFunc();
            }
        });

        //Kalkylfunktioner
        function flowFunc() {
            var speedCalc = speed.value.replace(",", ".");
            var radie = parseFloat(diameter.value, 10) / 2;
            var area = (radie * radie * Math.PI) / 1000;
            var velo = parseFloat(speedCalc, 10);
            var sum = area * velo * flowConv;

            var val = parseFloat(sum).toFixed(2);
            val = Number.isNaN(val) || "NaN" == val ? "" : val;

            flow.setAttribute("value", val);
            flow.value = trimValue(val);
        }

        function speedFunc() {
            var flowCalc = flow.value.replace(",", ".");
            var radie = parseFloat(diameter.value, 10) / 2;
            var area = (radie * radie * Math.PI) / 1000;
            var flowTwo = parseFloat(flowCalc, 10) / flowConv;
            var sum = flowTwo / area;

            var val = parseFloat(sum).toFixed(2);
            val = Number.isNaN(val) || "NaN" == val ? "" : val;

            speed.setAttribute("value", val);
            speed.value = trimValue(val);
        }

        function diameterFunc() {
            var speedCalc = speed.value.replace(",", ".");
            var flowCalc = flow.value.replace(",", ".");
            var flowTwo = parseFloat(flowCalc, 10) / flowConv;
            var velo = parseFloat(speedCalc, 10);
            var area = flowTwo / velo;
            var sum = 2 * Math.sqrt((area * 1000) / Math.PI);

            var val = parseFloat(sum).toFixed(2);
            val = Number.isNaN(val) || "NaN" == val ? "" : val;

            diameter.setAttribute("value", val);
            diameter.value = trimValue(val);
        }

        function trimValue(value) {
            // Return empty string if value is empty or would result in NaN
            if (value === "" || value === null || value === undefined) {
                return "";
            }

            var parts =
                value
                    .toString()
                    .split(".")
                    .map(e => parseInt(e)) || 0;

            const [base, decimal] = parts;

            // If base is NaN, return empty string
            if (Number.isNaN(base)) {
                return "";
            }

            if (2 <= parts.length) {
                return 10 >= base && 100 > base
                    ? parseFloat(value).toFixed(2)
                    : 100 >= base && 10 < base
                        ? parseFloat(value).toFixed(1)
                        : base;
            } else {
                return base;
            }
        }

        //Eventlisteners
        diameter.addEventListener("input", function () {
            if ("flow" == type.value) {
                if ("" == speed.value) {
                    return;
                } else {
                    flowFunc();
                }
            } else if ("speed" == type.value) {
                if ("" == flow.value) {
                    return;
                } else {
                    speedFunc();
                }
            }
        });

        speed.addEventListener("input", function () {
            if ("flow" == type.value) {
                if ("" == diameter.value) {
                    return;
                } else {
                    flowFunc();
                }
            } else if ("diameter" == type.value) {
                if ("" == flow.value) {
                    return;
                } else {
                    diameterFunc();
                }
            }
        });

        flow.addEventListener("input", function () {
            if ("speed" == type.value) {
                if ("" == diameter.value) {
                    return;
                } else {
                    speedFunc();
                }
            } else if ("diameter" == type.value) {
                if ("" == flow.value) {
                    return;
                } else {
                    diameterFunc();
                }
            }
        });
    }

    expansionCalculator() {
        if (!document.querySelector(".block-calculator-lu")) {
            return;
        }

        //IDn och Variabler
        var dimID = document.getElementById("gpa-lu-diameter");
        var instTempID = document.getElementById("gpa-lu-insttemp");
        var minTempID = document.getElementById("gpa-lu-mintemp");
        var maxTempID = document.getElementById("gpa-lu-maxtemp");
        var lengthID = document.getElementById("gpa-lu-length");

        //var elbowID = document.getElementById("gpa-lu-elbow");
        var materialID = document.getElementById("gpa-lu-material");
        var changeFactorID = document.getElementById("gpa-lu-a");
        var propID = document.getElementById("gpa-lu-k");
        var tempDiffID = document.getElementById("gpa-lu-t");
        var tempDiffIDmin = document.getElementById("gpa-lu-tmin");
        var changeID = document.getElementById("gpa-lu-l");
        var changeIDmin = document.getElementById("gpa-lu-lc");
        var elbowLeastID = document.getElementById("gpa-lu-b");
        var lang = document.getElementById("lang");

        var dimVar = 0;
        var instTempVar = 0;
        var minTempVar = 0;
        var maxTempVar = 0;
        var lengthVar = 0;
        var lengthContractionVar = 0;
        var elbowVar = 0;
        var changeFactorVar = 0.18;
        var propVar = 26;
        var tempDiffVar = 0;
        var instTempDiffVar = 0;
        var changeVar = 0;
        var changeVarContraction = 0;
        var elbowLeastVar = 0;

        changeFactorID.value = changeFactorVar;
        propID.value = propVar;

        changeFactorID.disabled = true;
        propID.disabled = true;
        tempDiffID.disabled = true;
        changeID.disabled = true;
        elbowLeastID.disabled = true;

        // Funktion som kollar om alla obligatoriska fält i "Förhållanden" är ifyllda
        function forhallandenFilled() {
            return (
                dimID.value.trim() !== "" &&
                instTempID.value.trim() !== "" &&
                minTempID.value.trim() !== "" &&
                maxTempID.value.trim() !== "" &&
                lengthID.value.trim() !== ""
            );
        }

        // Funktion som rensar endast RESULTAT-fälten
        function clearResultFields() {
            changeID.value = "";
            changeIDmin.value = "";
            elbowLeastID.value = "";
        }

        // Gemensam funktion som uppdaterar alla beräkningar
        function updateCalculations() {
            tempDiff();
            InstTempDiff();
            lengthChange();
            lengthChangeContraction();
            elbowLeast();
        }

        // --- Event-lyssnare med kontroll ---
        materialID.addEventListener("input", function () {
            material();
            if (!forhallandenFilled()) {
                clearResultFields();
                return;
            }
            updateCalculations();
        });
        maxTempID.addEventListener("input", function () {
            tempDiff();
            if (!forhallandenFilled()) {
                clearResultFields();
                return;
            }
            updateCalculations();
        });
        minTempID.addEventListener("input", function () {
            tempDiff();
            InstTempDiff();
            if (!forhallandenFilled()) {
                clearResultFields();
                return;
            }
            updateCalculations();
        });
        instTempID.addEventListener("input", function () {
            InstTempDiff();
            if (!forhallandenFilled()) {
                clearResultFields();
                return;
            }
            updateCalculations();
        });
        lengthID.addEventListener("input", function () {
            if (!forhallandenFilled()) {
                clearResultFields();
                return;
            }
            updateCalculations();
        });

        dimID.addEventListener("input", function () {
            if (!forhallandenFilled()) {
                clearResultFields();
                return;
            }
            updateCalculations();
        });



        function material() {
            if ("pe" == materialID.value) {
                changeFactorVar = 0.18;
                propVar = 26;
                changeFactorID.value = changeFactorVar;
                propID.value = propVar;
            } else if ("pp" == materialID.value) {
                changeFactorVar = 0.15;
                propVar = 30;
                changeFactorID.value = changeFactorVar;
                propID.value = propVar;
            } else if ("pvdf" == materialID.value) {
                changeFactorVar = 0.12;
                propVar = 20;
                changeFactorID.value = changeFactorVar;
                propID.value = propVar;
            } else if ("pvcu" == materialID.value) {
                changeFactorVar = 0.08;
                propVar = 34;
                changeFactorID.value = changeFactorVar;
                propID.value = propVar;
            } else if ("cpvc" == materialID.value) {
                changeFactorVar = 0.07;
                propVar = 34;
                changeFactorID.value = changeFactorVar;
                propID.value = propVar;
            } else if ("ectfe" == materialID.value) {
                changeFactorVar = 0.08;
                propVar = 20;
                changeFactorID.value = changeFactorVar;
                propID.value = propVar;
            }
        }

        function tempDiff() {
            if (true === isNaN(parseFloat(instTempID.value))) {
                instTempVar = 0;
            } else {
                instTempVar = parseFloat(instTempID.value.replace(",", "."));
            }
            if (true === isNaN(parseFloat(maxTempID.value))) {
                maxTempVar = 0;
            } else {
                maxTempVar = parseFloat(maxTempID.value.replace(",", "."));
            }
            tempDiffVar = maxTempVar - instTempVar;
            tempDiffVar = Math.abs(tempDiffVar);
            tempDiffID.value = tempDiffVar;
        }

        function InstTempDiff() {
            if (true === isNaN(parseFloat(instTempID.value))) {
                instTempVar = 0;
            } else {
                instTempVar = parseFloat(instTempID.value.replace(",", "."));
            }
            if (true === isNaN(parseFloat(minTempID.value))) {
                minTempVar = 0;
            } else {
                minTempVar = parseFloat(minTempID.value.replace(",", "."));
            }
            instTempDiffVar = instTempVar - minTempVar;
            instTempDiffVar = Math.abs(instTempDiffVar);
            tempDiffIDmin.value = instTempDiffVar;
        }

        function lengthChange() {
            lengthVar = parseFloat(lengthID.value.replace(",", "."));
            if (true === isNaN(lengthVar)) {
                lengthVar = 0;
            } else if (0 === lengthVar) {
                lengthVar = 0;
            } else {
                changeVar = lengthVar * tempDiffVar * changeFactorVar;
                changeID.value = Math.ceil(changeVar);
            }
        }

        function lengthChangeContraction() {
            lengthContractionVar = parseFloat(lengthID.value.replace(",", "."));
            if (true === isNaN(lengthContractionVar)) {
                lengthContractionVar = 0;
            } else if (0 === lengthContractionVar) {
                lengthContractionVar = 0;
            } else {
                changeVarContraction = lengthContractionVar * instTempDiffVar * changeFactorVar;
                changeIDmin.value = Math.ceil(changeVarContraction);
            }
        }

        function elbowLeast() {
            dimVar = parseFloat(dimID.value.replace(",", "."));
            elbowVar = 0;
            if (true === isNaN(dimVar)) {
                dimVar = 0;
            }
            if (true === isNaN(elbowVar)) {
                elbowVar = 0;
            }

            const highestChange = Math.max(changeVar || 0, changeVarContraction || 0);

            elbowLeastVar = propVar * Math.sqrt(highestChange * dimVar, 2);

            if (true === isNaN(elbowLeastVar)) {
                elbowLeastVar = 0;
            }
            elbowLeastID.value = Math.ceil(elbowLeastVar);
        }
    }
    pressuredropCalculator() {
        if (!document.querySelector(".block-calculator-pd")) {
            return;
        }

        var poneID = document.getElementById("gpa-pd-pone");
        var ptwoID = document.getElementById("gpa-pd-ptwo");
        var ptwobID = document.getElementById("gpa-pd-ptwob");
        var pthreeID = document.getElementById("gpa-pd-pthree");
        var pfourID = document.getElementById("gpa-pd-pfour");
        var pfiveID = document.getElementById("gpa-pd-pfive");
        var psixID = document.getElementById("gpa-pd-psix");
        var psevenID = document.getElementById("gpa-pd-pseven");
        var pseightID = document.getElementById("gpa-pd-pseight");
        var psnineID = document.getElementById("gpa-pd-psnine");
        var dimID = document.getElementById("gpa-pd-dim");
        var flowID = document.getElementById("gpa-pd-flow");
        var lengthID = document.getElementById("gpa-pd-length");
        var densID = document.getElementById("gpa-pd-dens");
        var speedID = document.getElementById("gpa-pd-speed");
        var dropfID = document.getElementById("gpa-pd-dropFittings");
        var droppID = document.getElementById("gpa-pd-dropPipes");
        var dropAllID = document.getElementById("gpa-pd-dropAll");
        var lang = document.getElementById("lang");

        var poneVar = 0;
        var ptwoVar = 0;
        var ptwobVar = 0;
        var pthreeVar = 0;
        var pfourVar = 0;
        var pfiveVar = 0;
        var psixVar = 0;
        var psevenVar = 0;
        var pseightVar = 0;
        var psnineVar = 0;
        var dimVar = 0;
        var flowVar = 0;
        var lengthVar = 0;
        var densVar = 0;
        var speedVar = 0;
        var dropfVar = 0;
        var droppVar = 0;
        var dropAllVar = 0;

        speedID.disabled = true;
        dropfID.disabled = true;
        droppID.disabled = true;
        dropAllID.disabled = true;

        /* Beräkningsfunktioner */

        function poneCalc() {
            poneVar = parseFloat(
                0.51 *
                (densVar / (2 * Math.pow(10, 5))) *
                Math.pow(speedVar, 2) *
                parseInt(poneID.value)
            );
            if (true === isNaN(poneVar)) {
                poneVar = 0;
                return poneVar;
            } else {
                return poneVar;
            }
        }

        function ptwoCalc() {
            ptwoVar = parseFloat(
                0.34 *
                (densVar / (2 * Math.pow(10, 5))) *
                Math.pow(speedVar, 2) *
                parseInt(ptwoID.value)
            );
            if (true === isNaN(ptwoVar)) {
                ptwoVar = 0;
                return ptwoVar;
            } else {
                return ptwoVar;
            }
        }

        function ptwobCalc() {
            ptwobVar = parseFloat(
                1.2 *
                (densVar / (2 * Math.pow(10, 5))) *
                Math.pow(speedVar, 2) *
                parseInt(ptwobID.value)
            );
            if (true === isNaN(ptwobVar)) {
                ptwobVar = 0;
                return ptwobVar;
            } else {
                return ptwobVar;
            }
        }

        function pthreeCalc() {
            pthreeVar = parseFloat(
                0.3 *
                (densVar / (2 * Math.pow(10, 5))) *
                Math.pow(speedVar, 2) *
                parseInt(pthreeID.value)
            );
            if (true === isNaN(pthreeVar)) {
                pthreeVar = 0;
                return pthreeVar;
            } else {
                return pthreeVar;
            }
        }

        function pfourCalc() {
            pfourVar = parseFloat(
                0.14 *
                (densVar / (2 * Math.pow(10, 5))) *
                Math.pow(speedVar, 2) *
                parseInt(pfourID.value)
            );
            if (true === isNaN(pfourVar)) {
                pfourVar = 0;
                return pfourVar;
            } else {
                return pfourVar;
            }
        }

        function pfiveCalc() {
            pfiveVar = parseFloat(
                0.05 *
                (densVar / (2 * Math.pow(10, 5))) *
                Math.pow(speedVar, 2) *
                parseInt(pfiveID.value)
            );
            if (true === isNaN(pfiveVar)) {
                pfiveVar = 0;
                return pfiveVar;
            } else {
                return pfiveVar;
            }
        }

        function psixCalc() {
            psixVar = parseFloat(
                0.042 *
                (densVar / (2 * Math.pow(10, 5))) *
                Math.pow(speedVar, 2) *
                parseInt(psixID.value)
            );
            if (true === isNaN(psixVar)) {
                psixVar = 0;
                return psixVar;
            } else {
                return psixVar;
            }
        }

        function psevenCalc() {
            psevenVar = parseFloat(
                0.1 *
                (densVar / (2 * Math.pow(10, 5))) *
                Math.pow(speedVar, 2) *
                parseInt(psevenID.value)
            );
            if (true === isNaN(psevenVar)) {
                psevenVar = 0;
                return psevenVar;
            } else {
                return psevenVar;
            }
        }

        function pseightCalc() {
            pseightVar = parseFloat(
                0.97 *
                (densVar / (2 * Math.pow(10, 5))) *
                Math.pow(speedVar, 2) *
                parseInt(pseightID.value)
            );
            if (true === isNaN(pseightVar)) {
                pseightVar = 0;
                return pseightVar;
            } else {
                return pseightVar;
            }
        }

        function psnineCalc() {
            psnineVar = parseFloat(
                0.023 *
                (densVar / (2 * Math.pow(10, 5))) *
                Math.pow(speedVar, 2) *
                parseInt(psnineID.value)
            );
            if (true === isNaN(psnineVar)) {
                psnineVar = 0;
                return psnineVar;
            } else {
                return psnineVar;
            }
        }

        function speedCalc() {
            speedVar = (flowVar / (Math.pow(dimVar / 2, 2) * Math.PI)) * 1000;
            if (true === isNaN(speedVar)) {
                speedVar = 0;
            } else {
                speedID.value = parseFloat(speedVar).toFixed(3);
            }
            return speedVar;
        }

        function dropAllCalc() {
            dropAllVar = dropfVar + droppVar;
            dropAllID.value = parseFloat(dropAllVar).toFixed(3);
        }

        function dropPCalc() {
            dropfVar =
                poneVar +
                ptwoVar +
                ptwobVar +
                pthreeVar +
                pfourVar +
                pfiveVar +
                psixVar +
                psevenVar +
                pseightVar +
                psnineVar;
            if (true === isNaN(dropfVar)) {
                dropfVar = 0;
            } else {
                dropfID.value = parseFloat(dropfVar).toFixed(3);
                dropAllCalc();
            }
            return dropfVar;
        }

        function dropPiCalc() {
            droppVar =
                0.02 *
                (lengthVar / dimVar) *
                (densVar / (2 * Math.pow(10, 2))) *
                Math.pow(speedVar, 2);
            if (true === isNaN(droppVar)) {
                droppVar = 0;
            } else {
                droppID.value = parseFloat(droppVar).toFixed(3);
                dropAllCalc();
            }
            return droppVar;
        }

        function allParts() {
            poneCalc();
            ptwoCalc();
            ptwobCalc();
            pthreeCalc();
            pfourCalc();
            pfiveCalc();
            psixCalc();
            psevenCalc();
            pseightCalc();
            psnineCalc();
        }

        /* Eventlisteners */

        poneID.addEventListener("input", function () {
            poneCalc();
            speedCalc();
            dropPCalc();
            dropPiCalc();
        });

        ptwoID.addEventListener("input", function () {
            ptwoCalc();
            speedCalc();
            dropPCalc();
            dropPiCalc();
        });

        ptwobID.addEventListener("input", function () {
            ptwobCalc();
            speedCalc();
            dropPCalc();
            dropPiCalc();
        });

        pthreeID.addEventListener("input", function () {
            pthreeCalc();
            speedCalc();
            dropPCalc();
            dropPiCalc();
        });

        pfourID.addEventListener("input", function () {
            pfourCalc();
            speedCalc();
            dropPCalc();
            dropPiCalc();
        });

        pfourID.addEventListener("input", function () {
            pfourCalc();
            speedCalc();
            dropPCalc();
            dropPiCalc();
        });

        pfiveID.addEventListener("input", function () {
            pfiveCalc();
            speedCalc();
            dropPCalc();
            dropPiCalc();
        });

        psixID.addEventListener("input", function () {
            psixCalc();
            speedCalc();
            dropPCalc();
            dropPiCalc();
        });

        psevenID.addEventListener("input", function () {
            psevenCalc();
            speedCalc();
            dropPCalc();
            dropPiCalc();
        });

        pseightID.addEventListener("input", function () {
            pseightCalc();
            speedCalc();
            dropPCalc();
            dropPiCalc();
        });

        psnineID.addEventListener("input", function () {
            psnineCalc();
            speedCalc();
            dropPCalc();
            dropPiCalc();
        });

        dimID.addEventListener("input", function () {
            dimVar = parseFloat(dimID.value);
            speedCalc();
            allParts();
            dropPCalc();
            dropPiCalc();
            return dimVar;
        });

        flowID.addEventListener("input", function () {
            flowID.value.replace(",", ".");
            flowVar = parseFloat(flowID.value);
            speedCalc();
            allParts();
            dropPCalc();
            dropPiCalc();
            return flowVar;
        });

        lengthID.addEventListener("input", function () {
            lengthVar = parseInt(lengthID.value);
            speedCalc();
            dropPiCalc();
            return lengthVar;
        });

        densID.addEventListener("input", function () {
            densVar = parseInt(densID.value);
            speedCalc();
            poneCalc();
            allParts();
            dropPCalc();
            dropPiCalc();
            return densVar;
        });
    }

    listeners() {
        $(document).on(
            "keypress",
            '.calculator input[inputmode="numeric"]',
            function (evt) {
                var theEvent = evt || window.event;

                if ("paste" === theEvent.type) {
                    key = event.clipboardData.getData("text/plain");
                } else {
                    var key = theEvent.keyCode || theEvent.which;
                    key = String.fromCharCode(key);
                }
                var regex = /[0-9]|\.|-/;
                if (!regex.test(key)) {
                    theEvent.returnValue = false;
                    if (theEvent.preventDefault) {
                        theEvent.preventDefault();
                    }
                }
            }
        );

        $(document).on("click", ".clear-values", function (e) {
            e.preventDefault();

            var $bounds = $(this)
                .parent()
                .prev();
            $bounds.find("input").val("");
        });

        $(document).on("click", ".generate-pdf", function (e) {
            e.preventDefault();

            var $bounds = $(this)
                .parent()
                .prev();
            var $bounds_parent = $bounds.parent();

            $bounds.addClass("generating");

            $bounds_parent.LoadingOverlay("show", {
                imageClass: "jquery-loading-overlay-icon",
                image: ajax.templateUrl + "/assets/svg/loading.svg",
                imageResizeFactor: 1,
                zIndex: 800,
                background: "rgba(255, 255, 255, 1)"
            });

            html2PDF($bounds, {
                jsPDF: {
                    format: "a4"
                },
                imageType: "image/jpeg",
                output:
                    "calculation" + Math.floor(Math.random() * 99999) + ".pdf",
                init: function () { },
                success: function (pdf) {
                    $bounds.removeClass("generating");
                    $bounds_parent.LoadingOverlay("hide");

                    // window.open(pdf.output('bloburl'));
                    // pdf.output('dataurlnewwindow');
                    pdf.save(this.output);
                }
            });
        });
    }
}

export default Calculators;
